import React from 'react';
import { Archive as ArchiveIcon } from '@mui/icons-material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import LOOKUP from 'constants/lookup';
// Basic Components
import Button from 'screens/components/basic/Button';
import BranchSelectAutoCompleteInput from 'screens/components/basic/BranchSelectAutoCompleteInput';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import CardSimple from 'screens/components/basic/CardSimple';
import BranchMultiSelectAutoCompleteInput from 'screens/components/basic/BranchMultiSelectAutoCompleteInput';
import SelectInput from 'screens/components/basic/SelectInput';

const componentName = "CreditPayments";

const Header = (props) => (
    <CardSimple>
        <div className="row row_margin_none">
            <div className="col-xs-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.beginDate.name}
                    floatingLabelText={LOOKUP.report.common.beginDate.label + "*"}
                    hintText={LOOKUP.report.common.beginDate.label + "*"}
                    fullWidth={true}
                    required
                />
            </div> {/* .col */}
            <div className="col-xs-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.endDate.name}
                    floatingLabelText={LOOKUP.report.common.endDate.label + "*"}
                    hintText={LOOKUP.report.common.endDate.label + "*"}
                    fullWidth={true}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
                <BranchMultiSelectAutoCompleteInput
                    defaultValues={props.branchOptions}
                    className="report-branch-select"
                    name={componentName + LOOKUP.report.common.branchName}
                    label="Branches*"
                    floatingLabelText="Branches"
                    hintText="Select Branches to display"
                    options={props.branchOptions}
                    fieldName={'Branches'}
                    updateStateImmediately
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
                <SelectInput
                    name={componentName + "GroupBy"}
                    defaultValue="Day"
                    fullWidth={true}
                    label={"Report By"}
                    floatingLabelText={"Report By"}
                    hintText={"Report By"}
                    options={[
                        { text: "Day", value: "Day" },
                        { text: "Week", value: "Week" },
                        { text: "Month", value: "Month" }
                    ]}
                />
            </div>
            <div className="col-xs-12 col-sm-12 col-lg-12 col-xl-12">
                <Button
                    type="IconInButton"
                    className="pull-right mt-2 ml-2 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.viewReport.name}
                    label={LOOKUP.report.common.viewReport.label}
                    icon={<VisibilityIcon />}
                    onTouchTap={props.showBody}
                />
                <Button
                    type="DownloadButton"
                    className="pull-right mt-2 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.downloadReport.name}
                    label={LOOKUP.report.common.downloadReport.label}
                    onTouchTap={props.download}
                />
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <p className='purpleText'><b>Note: </b><strong className="blue-text"><i>Only completed & partially refunded orders will be used in this report.</i></strong></p>
            </div>
        </div>
    </CardSimple>
);

export default Header;
